/** CelebrationLayer — flashes the configured celebration message across the screen. */
import { useEffect, useState } from "react";

export default function CelebrationLayer() {
  const [flash, setFlash] = useState(null);

  useEffect(() => {
    let timer;
    const onCelebrate = (e) => {
      const { message, duration } = e.detail || {};
      if (!message) return;
      setFlash({ message, key: Date.now() });
      clearTimeout(timer);
      timer = setTimeout(() => setFlash(null), Math.min(duration || 3500, 15000));
    };
    window.addEventListener("acq-celebrate", onCelebrate);
    return () => { window.removeEventListener("acq-celebrate", onCelebrate); clearTimeout(timer); };
  }, []);

  if (!flash) return null;
  return (
    <div className="fixed inset-x-0 top-16 z-[9998] flex justify-center pointer-events-none" data-testid="celebration-flash">
      <style>{`
        @keyframes acqFlashIn {
          0% { opacity: 0; transform: translateY(-24px) scale(0.85); }
          55% { opacity: 1; transform: translateY(4px) scale(1.04); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes acqShimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
      `}</style>
      <div
        key={flash.key}
        className="px-6 py-3 border-2 border-amber-400/70 bg-background/95 backdrop-blur-md shadow-[0_10px_40px_rgba(245,158,11,0.35)]"
        style={{ animation: "acqFlashIn 0.45s cubic-bezier(0.22,1,0.36,1)" }}
      >
        <div
          className="text-lg sm:text-xl font-black text-center bg-clip-text text-transparent"
          style={{
            fontFamily: "var(--font-heading)",
            backgroundImage: "linear-gradient(90deg, #f59e0b, #ef4444, #8b5cf6, #f59e0b)",
            backgroundSize: "200% 100%",
            animation: "acqShimmer 2.5s linear infinite",
          }}
          data-testid="celebration-message"
        >
          {flash.message}
        </div>
      </div>
    </div>
  );
}
